/** @module csi/page/HelpPane */
define([
	"csi/html",
	"csi/html/View",
	"csi/state/rootStore",
	"csi/view"
], function(html, HtmlView, {sessionStore}, csiView) {

	/** Starting split position */
	let _lastSplit = 1;

	/**
	 * Show or hide the help pane
	 * @param {boolean} bShow
	 */
	function showView(bShow) {
		const splitPane = html.pageSplit();
		if (!splitPane) {
			return;
		}

		const rightPane = splitPane.pane2;
		const isShown = isActive();

		// record split when closed
		if (!bShow) {
			_lastSplit = splitPane.get("split");
		}

		// allow resizing when showing page
		if (bShow !== isShown) {
			splitPane.set("frozen", !bShow);
			splitPane.set("split", bShow ? _lastSplit : 1);
		}

		sessionStore.showHelp = bShow;
		html.clear(rightPane, true);

		if (bShow) {
			const defView = Object.assign(new HtmlView(), {
				m_id: "__PageHelp__",
				m_typeView: "Html",
				classController: "csi/page/HelpView"
			});

			const view = csiView.newView(defView, sessionStore.currentUser);
			view.placeAt(rightPane);
			view.startup();
		}
	}

	/**
	 * Toggle the help view 
	 */
	function toggle() {
		showView(!isActive());
	}

	/**
	 * Close right pane
	 */
	function close() {
		if (isActive()) {
			showView(false);
		}
	}

	/**
	 * Return true if help pane is shown
	 * @return {boolean}
	 */
	function isActive() {
		return sessionStore.showHelp;
	}

	return {
		close,
		isActive,
		toggle
	};
});